import { Component } from '@angular/core'

import { TranslatePipe } from '@ngx-translate/core'

@Component({
  selector: 'dhp-filter-items-loading',
  templateUrl: './filter-items-loading.html',
  imports: [TranslatePipe],
})
export class FilterItemsLoading {}
